<template>
  <div class="materialPayTypeSubscript">
    <div :class="[IsOldUser ? 'commonVip' : 'pro']" v-if="showWho == 'sceneAnimation' || showWho === 'artword'">
    </div>
    <template v-else>
      <div :class="getBadgeClassName(4, 'enterpriseS')" v-if="showWho == 'enterpriseS'">
      </div>
      <img class="commonVip" v-if="showWho == 'commonVip'" />
      <img :class="getBadgeClassName(6, 'companyVip')" v-if="showWho == 'companyVip'" />
      <span class="price" v-if="showWho == 'price'">￥{{ (item.price || 0).toFixed(2) }}</span>
      <span class="discount" v-if="showWho == 'discount'"
        >￥{{ (item.price || 0).toFixed(2) }}
      </span>
      <img class="bought" v-if="showWho == 'bought'" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import vipBadge from '@/components/mixins/vipBadge';

export default {
  name: "materialPayTypeSubscript",
  mixins: [vipBadge],
  components: {},
  props: {
    localType: '',
    item: {
      payType: 0,
      price: 0,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["UserLevelType", 'IsOldUser']),
    showWho: function () {
      if (this.localType == 'sceneAnimation' || this.localType === 'artword') {
        return this.localType;
      }
      let type = (this.item || {}).payType;
      if (this.item.payType == 0) {
        return "free";
      } else if ((type === 1 || type === 2 || type === 3) && this.UserLevelType < 3) {
        if (this.item.tt) {
          return "bought";
        } else {
          return 'price';
        }
      } else if (this.item.payType == 4) {
        if (this.IsOldUser) {
          return "commonVip";
        }
        return 'enterpriseS';
      } else if (this.item.payType == 6) {
        return "companyVip";
      } else {
        return "free";
      }
    },
  },
  watch: {},
  methods: {},
};
</script>

<style scoped lang="scss">
.materialPayTypeSubscript {
  // position: absolute;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.free {
  display: none;
}
.price,
.discount {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 43px;
  height: 16px;
  // background: linear-gradient(108deg, #fa2efc 0%, #325eff 99%);
  border-radius: 4px;
  font-size: 12px;
  color: #F21616;
}
.bought {
  width: 50px;
  height: 16px;
  content: url("../../../../static/svg/payTypeSubscript/bought50x16.svg");
}
.commonVip {
  width: 36px;
  height: 16px;
  content: url("../../../../static/svg/payTypeSubscript/commonVip.svg");
}
.companyVip {
  width: 50px;
  height: 16px;
  content: url("../../../../static/svg/payTypeSubscript/companyVip50x16.svg");
}
.enterpriseS {
  width: 50px;
  height: 16px;
  // content: url(../../../assets/enterpriseS.png);
  content: url(../../../assets/enterpriseSVIP.svg);
}
.pro {
  width: 30px;
  height: 18px;
  content: url(../../../assets/pro.png);
}
.proPlus {
  width: 32px;
  height: 18px;
  content: url(../../../assets/proPlus.png);
}
</style>



// WEBPACK FOOTER //
// src/components/topnav/riskDrop/priceTag.vue